import { defineMessages } from 'react-intl';

const scope = 'cb.screens.Preferences';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Preferences',
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage: 'Tell us where to look and what you like, and we will tailor your coupons.',
  },
  backToAccount: {
    id: `${scope}.backToAccount`,
    defaultMessage: '← Back to My Account',
  },
  couldNotUpdatePreferencesError: {
    id: `${scope}.couldNotUpdatePreferencesError`,
    defaultMessage: 'Error! Could not update preferences.',
  },
  preferencesSaved: {
    id: `${scope}.preferencesSaved`,
    defaultMessage: 'Preferences saved.',
  },
  selectDistance: {
    id: `${scope}.selectDistance`,
    defaultMessage: 'Search radius',
  },
  categoriesTitle: {
    id: `${scope}.categoriesTitle`,
    defaultMessage: 'Categories you follow',
  },
  categoriesHint: {
    id: `${scope}.categoriesHint`,
    defaultMessage: 'Pick as many as you like.',
  },
  saveBtn: {
    id: `${scope}.saveBtnLabel`,
    defaultMessage: 'Save',
  },
});